import React from 'react';
import { Card, Container, Row, Col, Button } from 'react-bootstrap';

const Home = () => {
  return (
    <div style={{
      backgroundColor: '#0a1929',
      minHeight: '100vh',
      padding: '20px 0',
      background: 'linear-gradient(135deg, #0a1929 0%, #0d281c 100%)'
    }}>
      <Container className="py-5">
        {/* Header Section */}
        <div className="text-center mb-5">
          <div className="d-flex justify-content-center align-items-center mb-3">
            <div style={{
              width: '70px',
              height: '70px',
              backgroundColor: '#2e8b57',
              borderRadius: '50%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              marginRight: '15px'
            }}>
              <svg width="40" height="40" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 15V17M6 21H18C19.1046 21 20 20.1046 20 19V13C20 11.8954 19.1046 11 18 11H6C4.89543 11 4 11.8954 4 13V19C4 20.1046 4.89543 21 6 21ZM16 11V7C16 4.79086 14.2091 3 12 3C9.79086 3 8 4.79086 8 7V11H16Z" stroke="#e0f2e9" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </div>
            <h1 className="text-light" style={{ fontWeight: '700', fontSize: '2.5rem' }}>WBUOA Admin Portal</h1>
          </div>
          <p className="text-light" style={{ maxWidth: '600px', margin: '0 auto', fontSize: '1.1rem', opacity: '0.85' }}>
            Centralized management system for users, documents, and committees
          </p>
        </div>

        {/* Stats Section */}
        <Row className="mb-5 justify-content-center">
          <Col md={8}>
            <div style={{
              backgroundColor: 'rgba(46, 139, 87, 0.15)',
              borderRadius: '12px',
              padding: '20px',
              border: '1px solid rgba(46, 139, 87, 0.3)'
            }}>
              <Row className="text-center">
                <Col>
                  <div className="text-light" style={{ fontSize: '2rem', fontWeight: '700' }}>142</div>
                  <div className="text-light" style={{ opacity: '0.8' }}>Active Users</div>
                </Col>
                <Col>
                  <div className="text-light" style={{ fontSize: '2rem', fontWeight: '700' }}>1,204</div>
                  <div className="text-light" style={{ opacity: '0.8' }}>Documents</div>
                </Col>
                <Col>
                  <div className="text-light" style={{ fontSize: '2rem', fontWeight: '700' }}>28</div>
                  <div className="text-light" style={{ opacity: '0.8' }}>Committees</div>
                </Col>
              </Row>
            </div>
          </Col>
        </Row>

        {/* Features Section */}
        <h2 className="text-light text-center mb-4" style={{ fontWeight: '600' }}>Management Dashboard</h2>
        <Row className="g-4">
          <Col md={4}>
            <Card className="h-100" style={{
              backgroundColor: 'rgba(10, 50, 30, 0.7)',
              border: '1px solid rgba(46, 139, 87, 0.4)',
              borderRadius: '12px',
              transition: 'transform 0.3s, box-shadow 0.3s',
              boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
            }}>
              <Card.Body className="d-flex flex-column">
                <div style={{
                  width: '60px',
                  height: '60px',
                  backgroundColor: 'rgba(46, 139, 87, 0.2)',
                  borderRadius: '12px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  marginBottom: '20px'
                }}>
                  <svg width="30" height="30" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M16 21V19C16 17.9391 15.5786 16.9217 14.8284 16.1716C14.0783 15.4214 13.0609 15 12 15H5C3.93913 15 2.92172 15.4214 2.17157 16.1716C1.42143 16.9217 1 17.9391 1 19V21M23 21V19C22.9993 18.1137 22.7044 17.2528 22.1614 16.5523C21.6184 15.8519 20.8581 15.3516 20 15.13M17 7C17 9.20914 15.2091 11 13 11C10.7909 11 9 9.20914 9 7C9 4.79086 10.7909 3 13 3C15.2091 3 17 4.79086 17 7Z" stroke="#3cb371" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </div>
                <Card.Title className="text-light" style={{ fontSize: '1.5rem', fontWeight: '600' }}>Users Management</Card.Title>
                <Card.Text className="text-light" style={{ opacity: '0.8', flexGrow: '1' }}>
                  Manage all users, their roles and permissions in the system. Create, edit, or deactivate accounts with granular access controls.
                </Card.Text>
                <Button variant="outline-success" className="mt-3 align-self-start">Manage Users</Button>
              </Card.Body>
            </Card>
          </Col>
          
          <Col md={4}>
            <Card className="h-100" style={{
              backgroundColor: 'rgba(10, 50, 30, 0.7)',
              border: '1px solid rgba(46, 139, 87, 0.4)',
              borderRadius: '12px',
              transition: 'transform 0.3s, box-shadow 0.3s',
              boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
            }}>
              <Card.Body className="d-flex flex-column">
                <div style={{
                  width: '60px',
                  height: '60px',
                  backgroundColor: 'rgba(46, 139, 87, 0.2)',
                  borderRadius: '12px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  marginBottom: '20px'
                }}>
                  <svg width="30" height="30" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M14 2H6C5.46957 2 4.96086 2.21071 4.58579 2.58579C4.21071 2.96086 4 3.46957 4 4V20C4 20.5304 4.21071 21.0391 4.58579 21.4142C4.96086 21.7893 5.46957 22 6 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V8L14 2Z" stroke="#3cb371" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M14 2V8H20" stroke="#3cb371" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M16 13H8" stroke="#3cb371" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M16 17H8" stroke="#3cb371" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M10 9H9H8" stroke="#3cb371" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </div>
                <Card.Title className="text-light" style={{ fontSize: '1.5rem', fontWeight: '600' }}>Documents</Card.Title>
                <Card.Text className="text-light" style={{ opacity: '0.8', flexGrow: '1' }}>
                  Upload, categorize and manage all official documents. Maintain version control and track document access history.
                </Card.Text>
                <Button variant="outline-success" className="mt-3 align-self-start">Access Documents</Button>
              </Card.Body>
            </Card>
          </Col>
          
          <Col md={4}>
            <Card className="h-100" style={{
              backgroundColor: 'rgba(10, 50, 30, 0.7)',
              border: '1px solid rgba(46, 139, 87, 0.4)',
              borderRadius: '12px',
              transition: 'transform 0.3s, box-shadow 0.3s',
              boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
            }}>
              <Card.Body className="d-flex flex-column">
                <div style={{
                  width: '60px',
                  height: '60px',
                  backgroundColor: 'rgba(46, 139, 87, 0.2)',
                  borderRadius: '12px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  marginBottom: '20px'
                }}>
                  <svg width="30" height="30" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M17 21V19C17 17.9391 16.5786 16.9217 15.8284 16.1716C15.0783 15.4214 14.0609 15 13 15H5C3.93913 15 2.92172 15.4214 2.17157 16.1716C1.42143 16.9217 1 17.9391 1 19V21M23 21V19C22.9993 18.1137 22.7044 17.2528 22.1614 16.5523C21.6184 15.8519 20.8581 15.3516 20 15.13M16 3.13C16.8604 3.3503 17.623 3.8507 18.1676 4.55231C18.7122 5.25392 19.0078 6.11683 19.0078 7.005C19.0078 7.89317 18.7122 8.75608 18.1676 9.45769C17.623 10.1593 16.8604 10.6597 16 10.88M13 7C13 9.20914 11.2091 11 9 11C6.79086 11 5 9.20914 5 7C5 4.79086 6.79086 3 9 3C11.2091 3 13 4.79086 13 7Z" stroke="#3cb371" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </div>
                <Card.Title className="text-light" style={{ fontSize: '1.5rem', fontWeight: '600' }}>Committees</Card.Title>
                <Card.Text className="text-light" style={{ opacity: '0.8', flexGrow: '1' }}>
                  Manage unit, state committees and office bearers. Track committee memberships, terms, and responsibilities.
                </Card.Text>
                <Button variant="outline-success" className="mt-3 align-self-start">View Committees</Button>
              </Card.Body>
            </Card>
          </Col>
        </Row>

        {/* Additional Section */}
        <Row className="mt-5">
          <Col md={12}>
            <div style={{
              backgroundColor: 'rgba(10, 50, 30, 0.5)',
              borderRadius: '12px',
              padding: '25px',
              border: '1px solid rgba(46, 139, 87, 0.3)',
              marginTop: '30px'
            }}>
              <Row className="align-items-center">
                <Col md={8}>
                  <h3 className="text-light mb-3">Need Assistance?</h3>
                  <p className="text-light" style={{ opacity: '0.8' }}>
                    Our support team is available 24/7 to help you with any questions or issues you might encounter. Check our knowledge base or submit a support ticket.
                  </p>
                  <div className="d-flex mt-4">
                    <Button variant="success" className="me-3">Support Portal</Button>
                    <Button variant="outline-light">Knowledge Base</Button>
                  </div>
                </Col>
                <Col md={4} className="text-center d-none d-md-block">
                  <div style={{
                    width: '100px',
                    height: '100px',
                    backgroundColor: 'rgba(60, 179, 113, 0.15)',
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    margin: '0 auto'
                  }}>
                    <svg width="50" height="50" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M18 8C18 6.4087 17.3679 4.88258 16.2426 3.75736C15.1174 2.63214 13.5913 2 12 2C10.4087 2 8.88258 2.63214 7.75736 3.75736C6.63214 4.88258 6 6.4087 6 8C6 15 3 17 3 17H21C21 17 18 15 18 8Z" stroke="#3cb371" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                      <path d="M13.73 21C13.5542 21.3031 13.3019 21.5547 12.9982 21.7295C12.6946 21.9044 12.3504 21.9965 12 21.9965C11.6496 21.9965 11.3054 21.9044 11.0018 21.7295C10.6982 21.5547 10.4458 21.3031 10.27 21" stroke="#3cb371" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  </div>
                </Col>
              </Row>
            </div>
          </Col>
        </Row>

        {/* Footer */}
        
      </Container>
    </div>
  );
};

export default Home;